/* SMPR: uniform product card images - updated 31 Aug 2026.
   Two jobs, kept in one file so the whole change is a single line to remove:
   1. Show the WHOLE photo in each tile (object-fit: contain). The live theme's
      product-card-item.css had been switched to `cover`, which crops landscape
      photos to a zoomed full-bleed slab (e.g. the iPhone 15 Pro Max card).
   2. Measure where the product actually sits inside each photo and scale the
      image so every product reads at the same visual size on the grid.
   To disable: remove the script tag from snippets/back-to-top.liquid. */
(function () {
  if (window.__smprFit) return;
  window.__smprFit = 1;

  /* ---- 1. no cropping ------------------------------------------------- */
  var st = document.createElement("style");
  st.id = "smpr-card-fit-css";
  st.textContent =
    ".product-grid-item__thumbnail .media > img{" +
    "object-fit:contain !important;object-position:center center !important;" +
    "width:100% !important;height:100% !important;" +
    "background-color:#fff;padding:10px;box-sizing:border-box;}";
  (document.head || document.documentElement).appendChild(st);

  /* ---- 2. equalise product scale -------------------------------------- */
  var TARGET = 0.82;   // fraction of the card the product should fill
  var WHITE = 246;     // >= this on R,G,B counts as background
  var cache = {};
  var cv = document.createElement("canvas");
  var cx = cv.getContext("2d", { willReadFrequently: true });

  function measure(src, cb) {
    if (cache[src] !== undefined) { cb(cache[src]); return; }
    var m = new Image();
    m.crossOrigin = "anonymous";
    m.onerror = function () { cache[src] = null; cb(null); };
    m.onload = function () {
      var W = m.naturalWidth, H = m.naturalHeight;
      if (!W || !H) { cache[src] = null; cb(null); return; }
      cv.width = W; cv.height = H;
      cx.clearRect(0, 0, W, H);
      var d;
      try {
        cx.drawImage(m, 0, 0);
        d = cx.getImageData(0, 0, W, H).data;
      } catch (e) { cache[src] = null; cb(null); return; }

      var minX = W, minY = H, maxX = -1, maxY = -1, edgeBg = 0, edgeN = 0;
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          var i = (y * W + x) * 4;
          var bg = d[i + 3] < 16 || (d[i] > WHITE && d[i + 1] > WHITE && d[i + 2] > WHITE);
          if (y === 0 || y === H - 1 || x === 0 || x === W - 1) { edgeN++; if (bg) edgeBg++; }
          if (!bg) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }

      var tf = null;
      // skip coloured / full-bleed photos - trimming those looks wrong
      if (maxX >= 0 && edgeN > 0 && edgeBg / edgeN > 0.9) {
        var M = Math.max(W, H);
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var fill = Math.max(bw, bh) / M;
        var s = Math.max(0.6, Math.min(1.8, TARGET / fill));
        var ax = (minX + maxX + 1) / 2, ay = (minY + maxY + 1) / 2;
        var tx = -100 * s * (ax - W / 2) / M;
        var ty = -100 * s * (ay - H / 2) / M;
        if (Math.abs(s - 1) >= 0.03 || Math.abs(tx) >= 1 || Math.abs(ty) >= 1) {
          tf = "translate(" + tx.toFixed(2) + "%," + ty.toFixed(2) + "%) scale(" + s.toFixed(3) + ")";
        }
      }
      cache[src] = tf;
      cb(tf);
    };
    m.src = src;
  }

  function one(img) {
    if (img.getAttribute("data-smpr")) return;
    var cur = img.currentSrc || img.src;
    // Shopify serves product images from /cdn/shop/ on the shop domain and from
    // cdn.shopify.com elsewhere - accept both, skip anything else.
    if (!cur || (cur.indexOf("/cdn/shop/") === -1 && cur.indexOf("cdn.shopify.com") === -1)) return;
    img.setAttribute("data-smpr", "1");
    measure(cur.split("?")[0] + "?width=200", function (tf) {
      if (tf) img.style.transform = tf;
    });
  }

  function scan() {
    var l = document.querySelectorAll(".product-grid-item__thumbnail .media > img");
    for (var i = 0; i < l.length; i++) {
      var im = l[i];
      if (im.complete && im.naturalWidth) one(im);
      else im.addEventListener("load", function () { one(this); }, { once: true });
    }
  }

  document.addEventListener("DOMContentLoaded", scan);
  window.addEventListener("load", scan);
  document.addEventListener("shopify:section:load", scan);

  var deb;
  new MutationObserver(function () {
    clearTimeout(deb);
    deb = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
